import React from "react";
import * as Helper from "../helpers.mjs";
import {fetchJson} from "../fetch.js";
import LoadingSpinner from '../components/loadingSpinner.mjs';

class DrawerRow extends React.Component {
    checkout() {
        const basket = this.props.basket;
        
        if (basket.type === 'forSchool') {
            fetchJson('/basket/activate/' + basket.id).then(r => {
                window.location.href = "/checkout/" + basket.id;
            });
        } else if (basket.type === 'Furniture') {
            window.location.href = "/furniture/checkout/" + (basket.id ? basket.id : '');
        } else if (Helper.isLibraryUser()) {
            return this.props.libsCheckout(basket);
        } else {
            fetchJson('/basket/activate/' + basket.id).then(r => {
                window.location.href = "/basket/checkout";
            });
        }
    }

    onChange(e) {
        this.props.onChange(e, this.props.basket.id);
    }

    render() {
        const basket = this.props.basket;

        if (basket.hasOwnProperty('deleted') && basket.deleted) {
            return null;
        }

        const readonly = basket.type === 'Furniture' || basket.id === 'new' ? 'readonly' : '';

        var active = false;
        if (basket.id == this.props.activeBasketId || basket.id === "new") {
            classes += " active";
            active = true;
        }

        var classes = 'basket';
        var basketNameColumnTitle = this.props.basket.name;
        if(basket.type === 'Furniture') {
            classes += ' furnitureBasket' 
        } else if(basket.type === 'forSchool') {
            classes += ' forSchoolBasket';
            basketNameColumnTitle = "School's basket " + "(" + this.props.basket.customerTitle + ")";
        }

        const showValues = (!!basket.quantity || basket.quantity == 0);

        if(basket.type === 'Furniture') {
            return (
                <tr data-id={basket.id} className={classes} >
                    <td className="basketActiveIcon"></td>
                    <td className="basketNameColumn" title={basketNameColumnTitle}>
                        <div className="basketDrawFlex">
                            <span style={{marginRight:"8px"}} className="basketName">{this.props.basket.name}</span>
                        </div>
                    </td>
                    {!!showValues && <>
                        <td>{basket.quantity}</td>
                        <td className="monetary">{Helper.currency(basket.total)}</td>
                    </>}
                    {!showValues && <td colSpan={2}><div class="text animatedEllipses">Loading<span>.</span><span>.</span><span>.</span></div></td>}
                    <td>{basket.id != "new" && <span title="Delete" onClick={this.props.delete} className="fas delete fa-trash small button"></span>}</td>
                    <td>{basket.id != "new" && <span title="Checkout" className="fas checkoutBasket fa-shopping-cart small button" onClick={this.checkout.bind(this)}></span>}</td>
                </tr>
            );
        } else {
            return (
                <tr data-id={basket.id} className={classes} onClick={this.props.activate}>
                    <td className="basketActiveIcon">
                        {!active && <i className="far fa-bolt" title="Set as active basket"></i>}
                        {active && <i className="fas fa-bolt" title="This is your active basket"></i>}
                    </td>
                    <td className="basketNameColumn" title={basketNameColumnTitle}>
                        <div className="basketDrawFlex">
                        {!readonly && <input className="basketName" value={this.props.basket.name} maxLength="20" readOnly={readonly} onChange={this.onChange.bind(this)} onBlur={this.props.rename} />}
                        {readonly && <span>{this.props.basket.name}</span>}
                        </div>
                    </td>
                    {!!showValues && <>
                        <td>{basket.quantity}</td>
                        <td className="monetary">{Helper.currency(basket.total)}</td>
                    </>}
                    {!showValues && <td colSpan={2}><div class="text animatedEllipses">Loading<span>.</span><span>.</span><span>.</span></div></td>}
                    <td>{basket.id != "new" && <span title="Delete" onClick={this.props.delete} className="fas delete fa-trash small button"></span>}</td>
                    <td>{basket.id != "new" && <span title="Checkout" className="fas checkoutBasket fa-shopping-cart small button" onClick={this.checkout.bind(this)}></span>}</td>
                </tr>
            );
        }
    }
}

class Drawer extends React.Component {
    render() {
        var baskets = [];
        for (var id in this.props.baskets) {
            var basket = this.props.baskets[id];
            if (basket.type != "Furniture" && basket.type != "wishlist") {
                baskets.push(basket);
            }
        }
        if (this.props.furnitureBasketId) {
            baskets.push(this.props.baskets[this.props.furnitureBasketId]);
        }
        if (baskets.filter(b => !b.deleted && b.type != "Furniture" && b.type != "wishlist").length === 0) {
            baskets.push({
                id: 'new',
                name: 'Basket',
                quantity: 0,
                total: '0.00'
            });
        }

        return (
            <div className="drawContainer">
                <div id="openDrawButton" onClick={this.props.toggleDrawer}>
                    <div className="basketButtonContents">
                        <div className="text">View my baskets</div>
                        <div className="icon"></div>
                    </div>
                </div>
                <div id="basketDrawItems">
                    <table cellSpacing={0} className="basketDrawItemsTable">
                        <thead className="basketDrawItemsTop basketDrawItemsTopTable"><tr><th></th><th>Name</th><th>Items</th><th>Total</th><th width={26}></th><th width={26}></th></tr></thead>
                        <tbody className="basketDrawItemsMiddle basketDrawItemsMiddleTable">
                            {baskets.map(basket => <DrawerRow key={basket.id} basket={basket} activate={this.props.activate} rename={this.props.rename} delete={this.props.delete} activeBasketId={this.props.activeBasketId} onChange={this.props.onChange} libsCheckout={this.props.libsCheckout} forSchoolCheckout={this.props.forSchoolCheckout} />)}
                            {baskets.length >= 10 &&
                                <tr>
                                    <td></td>
                                    <td colSpan={6}>
                                        <a className="simpleLink" target="_blank" href="/manage-baskets">All baskets</a>
                                    </td>
                                </tr>
                            }
                        </tbody>
                        <tfoot className="basketDrawItemsBottom basketDrawItemsBottomTable">
                            <tr className="newBasket">
                                <td></td>
                                <td id="newBasket" colSpan="2">
                                    {!Helper.isLibraryUser() && <input id="newBasketName" maxLength="20" type="text" placeholder="Create new basket" />}
                                </td>
                                <td colSpan="3">
                                    <span title="Add" id="addNewBasket" className="button small" onClick={this.props.addBasket}>ADD NEW BASKET</span>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        );
    }
}

export default Drawer;